import getItemsFromPath from 'utils/get-items-from-path'

const imageContext = require.context('./bg-images', false, /\.(png|jpe?g|svg)$/)
const thumbContext = require.context(
  './bg-images/thumbs',
  false,
  /\.(png|jpe?g|svg)$/
)

const backgroundImages = getItemsFromPath(imageContext)
const backgroundThumbs = getItemsFromPath(thumbContext)
export const BACKGROUND_IMAGES = Object.values(backgroundImages)
export const BACKGROUND_THUMBS = Object.values(backgroundThumbs)

export const BG_IMAGE_NAMES = Object.keys(backgroundImages)

export const isInBgImages = imageName => {
  return backgroundImages[imageName]
}

export const getImageSrc = name => {
  const bgName = name || BG_IMAGE_NAMES[0]
  return backgroundImages[bgName] || backgroundImages[BG_IMAGE_NAMES[0]]
}
